var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import '../TabLayout/tab-layout.css';
var TabLayout = function (_a) {
    var children = _a.children, _b = _a.items, items = _b === void 0 ? [] : _b, classNames = _a.classNames, active = _a.active, _c = _a.onTabClick, onTabClick = _c === void 0 ? function () { return undefined; } : _c, props = __rest(_a, ["children", "items", "classNames", "active", "onTabClick"]);
    return (React.createElement("section", __assign({}, props, { className: classnames(classNames, 'ins-tab-layout'), "widget-type": "InsightsTabs" }),
        React.createElement("div", { className: "ins-tabs" }, items.map(function (oneItem) { return (React.createElement("div", { key: oneItem.name, className: classnames({ active: oneItem.name === active }), onClick: function (event) { return onTabClick(event, oneItem); }, "widget-type": "InsightsTabsItem", "widget-id": oneItem.name }, oneItem.title)); })),
        React.createElement("div", { className: "ins-tab-content" }, children)));
};
export default TabLayout;
//# sourceMappingURL=TabLayout.js.map